import { Col, Row, SegmentControl, Text } from 'components';
import { useSearchParams } from 'react-router-dom';
import { Header } from 'screens/Admin/components';
import { FlaggedTab, LogsTab, PolicyTab, ProfanityTab, SpamTab, SystemBar } from './components';

const TABS = ['Policy', 'Logs', 'Flagged Queue', 'Profanity', 'Spam'];
const TAB_KEYS = ['policy', 'logs', 'flagged', 'profanity', 'spam'];

const Moderation = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabIdx = Math.max(0, TAB_KEYS.indexOf(searchParams.get('tab')));
  const setTab = (idx) => setSearchParams({ tab: TAB_KEYS[idx] });

  return (
    <Col noFlex wid="100%" ht="100vh" start>
      <Header>
        <Row center between wid="100%">
          <Text h3 col="#000">
            Content Moderation
          </Text>
        </Row>
      </Header>

      <Col start noFlex marg="54px 0 0" wid="100%" pad="24px" style={{ overflow: 'auto' }}>
        <SystemBar />

        <SegmentControl
          options={TABS}
          selectedIdx={tabIdx}
          handleSelect={setTab}
          small
          wid="620px"
          marg="0 0 20px"
          textStyle={{ size: '14px' }}
        />

        {tabIdx === 0 && <PolicyTab />}
        {tabIdx === 1 && <LogsTab />}
        {tabIdx === 2 && <FlaggedTab />}
        {tabIdx === 3 && <ProfanityTab />}
        {tabIdx === 4 && <SpamTab />}
      </Col>
    </Col>
  );
};

export default Moderation;
